import React from "react"
import { ICategory } from "../../../gatsby-graphql"
import { ContentWrapper } from "../../ui"
import {
  CategoriesBarWrapper,
  Categories,
  CategoryLink,
} from "./categories-bar-elements"
import CategoriesDropdown from "./categories-dropdown"
import { useTranslation } from "react-i18next"

interface CategoriesBarProps {
  data: ICategory[]
  basePath: string
  active?: string | null
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement>,
    categorySlug: string | null
  ) => void
}

const CategoriesBar = ({
  data,
  basePath,
  active,
  onClick,
}: CategoriesBarProps) => {
  const { t } = useTranslation()

  if (!data || data.length === 0) {
    return <></>
  } else if (data[0].slug !== null) {
    data.unshift({
      name: t("All"),
      slug: null,
    })
  }
  return (
    <CategoriesBarWrapper>
      <ContentWrapper>
        <CategoriesDropdown
          data={data}
          basePath={basePath}
          active={active}
          onClick={onClick}
        />
        <Categories>
          {data.map((category, index) => (
            <CategoryLink
              to={`${basePath}${category.slug || ""}`}
              onClick={e => {
                if (onClick) onClick(e, category.slug || null)
              }}
              activeClassName="active"
              className={active === category.slug ? "active" : ""}
              key={index}
            >
              {category.name}
            </CategoryLink>
          ))}
        </Categories>
      </ContentWrapper>
    </CategoriesBarWrapper>
  )
}

export default CategoriesBar
